import { createFileRoute } from "@tanstack/react-router";
import { AssetName } from "@/components/installFlowV2/asset-name";
import { z } from "zod";

export const Route = createFileRoute("/installFlow/asset-name")({
  component: AssetName,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
});
